<button type="button" class="cart-button" [attr.aria-label]="'navbar.cart.title' | translate"
  (click)="inCheckoutPage() ? navigateToCart() : cartOP.toggle($event)">
  <i class="pi pi-shopping-cart"></i>
  <span class="total-quantity" *ngIf="cartTotalQuantity$()">{{ cartTotalQuantity$() }}</span>
</button>

<p-overlayPanel #cartOP panelStyleClass="cart-overlay">
  <section class="cart-panel" *ngIf="cart$()">

    <!-- Header -->
    <header class="cart-panel__head">
      <h3 class="cart-panel__title">{{ 'navbar.cart.title' | translate }}</h3>
      <span class="cart-panel__count">{{ cartTotalQuantity$() }}</span>
    </header>

    <!-- Empty -->
    <div class="cart-empty" *ngIf="!cartItems$().length">
      <i class="pi pi-shopping-bag"></i>
      <p>{{ 'navbar.cart.emptyCart' | translate }}</p>
    </div>

    <!-- Items -->
    <ul class="cart-list" *ngIf="cartItems$().length">
      <li class="cart-item" *ngFor="let item of cartItems$(); let i = index">
        <img class="cart-item__img" [src]="item.icon" [alt]="item.name" />

        <div class="cart-item__info">
          <span class="cart-item__name">{{ item.name }}</span>
          <span class="cart-item__qty">
            {{ 'navbar.cart.quantity' | translate }}: {{ item.quantity }}
          </span>
          <strong class="cart-item__price">{{ item.price | currency : item.currency }}</strong>
        </div>

        <button type="button" class="cart-item__remove" *ngIf="!checkoutPageIsOpen()" aria-label="Remove"
          (click)="removeItem(item, i)">
          <i class="pi pi-trash"></i>
        </button>
      </li>
    </ul>

    <!-- Footer -->
    <footer class="cart-panel__foot" *ngIf="cartItems$().length">
      <div class="cart-total" *ngIf="cartTotal$()">
        <span class="cart-total__label">{{ 'navbar.cart.total' | translate }}</span>
        <strong class="cart-total__value">
          {{ currencyCalculator.convertCurrency(cartTotalPrice$(), cart$().currency, currency$(), exchanges) }}
          {{ currency$() }}
        </strong>
      </div>

      <div class="cart-actions">
        <button type="button" class="btn-ghost" (click)="navigate(language$() + '/settings/cart')">
          {{ 'navbar.cart.viewCart' | translate }}
        </button>
        <button type="button" class="btn-primary" (click)="navigate(language$() + '/checkout')">
          {{ 'navbar.cart.checkout' | translate }}
        </button>
      </div>
    </footer>

  </section>
</p-overlayPanel>